import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=08c22268&"
import script from "./EditRole.vue?vue&type=script&lang=ts&"
export * from "./EditRole.vue?vue&type=script&lang=ts&"
import style0 from "./EditRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports